export enum CustomWebToAppEvents {
  app_review = 'app_review',
  save_biometric_credentials = 'save_biometric_credentials',
  request_biometric_status = 'request_biometric_status',
  biometric_login_failed = 'biometric_login_failed',
}
